import React, {useState} from 'react';
import {Button, Form, Input, Modal, Typography} from 'antd';
import {login} from '../api/auth';
import {useAppDispatch} from '../hooks';
import {loginSuccess} from '../features/user/userSlice';
import FirmSelectorModal from './FirmSelectorModal';
import ForgotPasswordModal from "./ForgotPasswordModal";

interface LoginModalProps {
    open: boolean;
    onClose: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({open, onClose}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [firms, setFirms] = useState<any[]>([]);
    const [loginResult, setLoginResult] = useState<any>(null);
    const [isFirmSelectOpen, setIsFirmSelectOpen] = useState(false);

    const dispatch = useAppDispatch();

    const [showForgotPassword, setShowForgotPassword] = useState(false);

    const clickForgotPassword = async () => {
        setLoading(false);
        setError(null);
        // Open ForgotPassword component
        setShowForgotPassword(true);
        // Optionally, you can also reset the form or handle any other logic here
        form.resetFields();
    }

    const handleSubmit = async () => {
        try {
            setLoading(true);
            setError(null);
            const values = await form.validateFields();

            const result = await login(values);
            setLoginResult(result);

            localStorage.setItem('userFirms', JSON.stringify(result.firms));
            if (result.firms.length > 1) {
                setFirms(result.firms);
                setIsFirmSelectOpen(true); // ouvrir sélection si plusieurs firms
            } else {
                localStorage.setItem('selectedFirm', JSON.stringify(result.firms[0]));
                localStorage.setItem('user', JSON.stringify({
                    token: result.token,
                    username: values.username,
                    firms: result.firms,
                    user: result.user
                }));
                dispatch(loginSuccess({token: result.token, user: result.user}));
                form.resetFields();
                onClose();
            }
        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleFirmSelect = (firm: any) => {
        if (!loginResult) return;
        localStorage.setItem('selectedFirm', JSON.stringify(firm));
        localStorage.setItem('user', JSON.stringify({
            token: loginResult.token,
            username: loginResult.user.username,
            firms: loginResult.firms,
            user: loginResult.user
        }));
        dispatch(loginSuccess({
            token: loginResult.token,
            user: loginResult.user,
            firm: firm,
        }));
        setIsFirmSelectOpen(false);
        form.resetFields();
        onClose();
    };

    return (
        <>
            <Modal
                open={open}
                onCancel={onClose}
                footer={null}
                title="Connexion"
            >
                <Form form={form} layout="vertical"
                    // onFinish={handleSubmit}
                >
                    <Form.Item
                        label="Nom d'utilisateur"
                        name="username"
                        rules={[{required: true, message: 'Champ requis'}]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Mot de passe"
                        name="password"
                        rules={[{required: true, message: 'Champ requis'}]}
                    >
                        <Input.Password/>
                    </Form.Item>

                    {error && (
                        <Typography.Text type="danger">{error}</Typography.Text>
                    )}

                    <Form.Item style={{marginTop: '1rem'}}>
                        <Button type="primary" htmlType="submit"
                                onClick={handleSubmit}
                                loading={loading} block>
                            Se connecter
                        </Button>
                        <Button type={"link"}
                                loading={loading}
                                onClick={clickForgotPassword}>
                            Mot de passe oublié ?
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <FirmSelectorModal
                open={isFirmSelectOpen}
                firms={firms}
                onCancel={() => setIsFirmSelectOpen(false)}
                onSelect={handleFirmSelect}
            />

            <ForgotPasswordModal
                open={showForgotPassword}
                onCancel={() => setShowForgotPassword(false)}
            />

        </>
    );
};

export default LoginModal;
